// @flow

import type { InteractivesMenuItemConfig } from "../interactives-list";
import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import DisplayImage from "./image.png";

const description =
  "A small interactive that invites users to find 'How safe is your city?', launching them into the Crime Dashboard interactive with a focus on their area.";

const CONFIG: InteractivesMenuItemConfig = {
  name: "Crime launch pad",
  id: "crime-launch-pad",
  linkPrefix: "/interactives",
  tags: ["Crime", "Data viz", "Configurable"],
  description,
  image: DisplayImage,
  adminOnly: false,
  cradleIframeUrlRoot:
    "https://www.theage.com.au/interactive/2018/crime-launch-pad/?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "CrimeLaunchPadConfigTool" */ "app/components/tools/CrimeLaunchPadConfigTool/CrimeLaunchPadConfigTool"),
    loading: DynamicImportLoader,
    modules: ["CrimeLaunchPadConfigTool"]
  })
};

export default CONFIG;
